import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { SftpComponent } from './sftp.component';
import { SftpRoutingModule } from './sftp-routing.module';
@NgModule({
    declarations: [SftpComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaskedTextBoxModule,
        SftpRoutingModule,
        NgxUiLoaderModule,
        NgSelectModule,
        GridModule,
    ],
    exports: [SftpComponent]
})
export class SftpModule { }
